import React from "react";
import { connect } from "react-redux";
import { Row, Col, Form, Button } from "react-bootstrap";
// import { addDocAction, uploadDocumentAction } from "../../actions/DocActions";
import { publicAddDocAction, publicUploadDocumentAction } from "../../actions/DocActions";
// import { getTransactionDataAction } from "../../actions/TransactionActions";
import { getPublicFormTransactionDataAction } from "../../actions/TransactionActions";
import {
  logout,
  loginUserAction,
  loginUserPublicFormsAction,
  addContactByPublicFormAction
} from "../../actions/UserActions";
import {
  formatPhoneNumber,
  toastMessage,
  getContingencyData,
  getTimeFromMins,
  convertTimeToMinutes,
} from "../Common/Common";
import InputMask from "react-input-mask";
import SignaturePad from "react-signature-canvas";
import html2pdf from "html2pdf.js";
import Dropzone from "react-dropzone";
import moment from "moment";
import { AttachFile, DeleteOutline } from "@material-ui/icons";
import * as code from "./../../config/Constants";
import ImageUpload from "../Forms/ImageUpload";
import StickyHeaderPublic from "./StickyHeaderPublic";
import FooterPublic from "./FooterPublic";
var _ = require("lodash");

// var systemLoginValues = {
//   email: process.env.REACT_APP_SYSTEMLOGINVALUES_EMAIL,
//   password: process.env.REACT_APP_SYSTEMLOGINVALUES_PASSWARD,
// };

class IntakePublic extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      transactionId: this.props.formData && this.props.formData.transactionId,
      attachments: [],
      clientFirstName: "",
      clientLastName: "",
      clientEmail: "",
      clientPhone: "",
      guardianName: "",
      guardianEmail: "",
      guardianPhone: "",
      artistName: "",
      artistPhone: "",
      appointmentDate: "",
      artworkType: "",
      artworkDescription: "",
      hasGuardian: false,
      files: [],
      errors: {},
    };

    this.exportFormToPDF = this.exportFormToPDF.bind(this);
  }

  loginForPublicForm() {
    let data = { WEbEOpurMgk: "5GfFObGWzC5PNVTVbMA" };
    return this.props.loginUserPublicFormsAction(data).then((loginRes) => {});
  }

  /**
   * @desc delete image
   * @param {*} i
   */
  deleteImage(i) {
    var acceptedFiles = this.state.attachments;
    var filesData = this.state.files;
    filesData.splice(i, 1);
    acceptedFiles.splice(i, 1);
    this.setState({
      attachments: acceptedFiles,
      files: filesData,
    });
  }

  async getTransactionData() {
    //await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let transId = this.state.transactionId;
    let transaction = [];
    if (!(this.props.formData && this.props.formData.isBlankForm)) {
      await this.props
        .getPublicFormTransactionDataAction(transId)
        .then((transDataRes) => {
          transaction.push(this.props.transactionData);

          for (let i = 0; i < transaction.length; i++) {
            let time =
              moment(
                getContingencyData(
                  transaction[i].contingencies,
                  "First Appointment",
                  "startDate"
                )
              ).get("hour") +
              ":" +
              moment(
                getContingencyData(
                  transaction[i].contingencies,
                  "First Appointment",
                  "startDate"
                )
              ).get("minutes");
            let timeToMins = convertTimeToMinutes(time);
            let minsToTime = getTimeFromMins(timeToMins);

            this.setState({
              clientFirstName: transaction[i].dsd.buyer[0].firstname,
              clientLastName: transaction[i].dsd.buyer[0].lastname
                ? transaction[i].dsd.buyer[0].lastname
                : "",
              clientEmail: transaction[i].dsd.buyer[0].email,
              clientPhone: transaction[i].dsd.buyer[0].mobileNumber,
              guardianName:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].firstname +
                    " " +
                    transaction[i].dsd.closingAgents[0].lastname
                  : "",
              guardianEmail:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].email
                  : "",
              guardianPhone:
                transaction[i].dsd.closingAgents.length !== 0
                  ? transaction[i].dsd.closingAgents[0].mobileNumber
                  : "",
              artistName:
                transaction[i].dsd.listingAgents[0].firstname +
                " " +
                transaction[i].dsd.listingAgents[0].lastname,
              artistPhone: transaction[i].dsd.listingAgents[0].mobileNumber,
              appointmentDate:
                moment(
                  getContingencyData(
                    transaction[i].contingencies,
                    "First Appointment",
                    "startDate"
                  )
                ).format("MM/DD/YYYY") +
                " " +
                minsToTime,
              artworkType: transaction[i].transactionType,
              artworkDescription: transaction[i].dsd.heldBy,
              hasGuardian:
                transaction[i].dsd.closingAgents.length !== 0 ? true : false,
            });
          }
        });
    }
    this.props.logout();
  }

  componentDidMount() {
    this.getTransactionData();
  }

  uploadExtraDocuments = () => {
    let formData = new FormData();
    let dataToPost = {
      transactionId: this.state.transactionId,
      location: "Transaction Docs",
      document: this.state.attachments,
    };
    let e = this.state.files;
    if (e.length > 0) {
      for (let i = 0; i < e.length; i++) {
        // console.log("e[i]", e[i]);
        formData.append("file", e[i]);
      }
      // console.log("formData-380", formData);
      this.props.publicAddDocAction(dataToPost).then((res) => {
        if (res.status === code.OK) {
          let fileUploadName = "";
          res.data.map((item) => {
            if (fileUploadName.length > 0) {
              fileUploadName +=
                "@@@" + item.document + "###" + item.uploadedFileName;
            } else {
              fileUploadName = item.document + "###" + item.uploadedFileName;
            }
          });
          this.props
            .publicUploadDocumentAction(
              formData,
              this.state.transactionId,
              undefined,
              fileUploadName
            )
            .then((res) => {
              // console.log('VALID');
            });
        } else {
          toastMessage(code.ERROR, res.data);
        }
      });
    }
  };

  async exportFormToPDF() {
    // await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let form = document.getElementById("formToExport");

    let transId = this.state.transactionId;

    //Setup the filename
    const dt = new Date();
    let filestamp =
      "_" +
      dt.getFullYear().toString() +
      (dt.getMonth() + 1).toString() +
      dt.getDate().toString() +
      dt.getHours().toString() +
      dt.getMinutes().toString() +
      dt.getSeconds().toString();
    let clientFullName =
      this.state.clientFirstName.trim() +
      (this.state.clientLastName ? " " + this.state.clientLastName.trim() : "");
    let fileName =
      "intake" +
      (clientFullName ? "_" + clientFullName : "") +
      filestamp +
      ".pdf";
    let fn = fileName.split(" ").join("_");

    //Set the pdf Export Options
    let opt = {
      margin: 1.5,
      filename: fn,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2.5, width: 1200 },
      jsPDF: { unit: "in", format: "a1", orientation: "p" },
    };

    //Begin the fileupload setup
    var documents = [];
    var docDetail = {};

    //Exports the file to a blob
    const blob = await html2pdf()
      .set(opt)
      .from(form)
      .toPdf()
      .output("blob", fn);

    //Set the file details for the insert into the ducuments colection
    docDetail = {
      fileName: fn,
      size: (blob.size / (1024 * 1024)).toFixed(2),
    };
    documents.push(docDetail);

    var dataToPost = {
      transactionId: transId,
      location: "Transaction Docs",
      document: documents,
    };

    //Setup the formdata for the fileupload to s3
    var formData = new FormData();
    formData.append("file", blob, fn);

     //add client only for QR code scan link
     if (
      this.props.formData &&
      this.props.formData.isBlankForm &&
      (this.state.clientEmail || this.state.clientPhone)
    ) {
      let data = {
        firstname: this.state.clientFirstName,
        lastname: this.state.clientLastName,
        email: this.state.clientEmail,
        mobileNumber: this.state.clientPhone.replace(/-/g, ""),
        usertype: "Client",
        transactionId: transId,
        knowAboutUs: this.props.formData && this.props.formData.knowAboutUs,
      };
      this.props.addContactByPublicFormAction(data).then((res) => {});
    }


    //addDocAction writes the mongodb record about the file and returns the unique file name that will be stored in 33
    this.props.publicAddDocAction(dataToPost).then((res) => {
      if (res.status === code.OK) {
        var fileUploadName = "";
        res.data.map((item) => {
          if (fileUploadName.length > 0) {
            fileUploadName +=
              "@@@" + item.document + "###" + item.uploadedFileName;
          } else {
            fileUploadName = item.document + "###" + item.uploadedFileName;
          }
          //uploadDocumentAction actually sends the file to S3
          this.props
            .publicUploadDocumentAction(
              formData,
              transId,
              undefined,
              fileUploadName
            )
            .then((isValidDoc) => {
              // console.log("VALID");
              //Export the file for download
              html2pdf()
                .set(opt)
                .from(form)
                .save();
              this.props.logout();
              this.props.history.push("/formreceived");
            });
        });
      } else {
        //console.log("BAD addDocAction Status: " + res.status);
        toastMessage(code.ERROR, res.data);
      }
    });

    this.uploadExtraDocuments();
  }

  async uploadAttachments(e, transId) {
    // await this.props.loginUserAction(systemLoginValues);
    // await this.loginForPublicForm();

    let formData = new FormData();
    let documents = this.state.attachments;
    let docDetail = {};

    if (e.length > 0) {
      for (let i = 0; i < e.length; i++) {
        docDetail = {
          fileName: e[i].name,
          size: (e[i].size / (1024 * 1024)).toFixed(2),
        };
        documents.push(docDetail);
        formData.append("file", e[i]);
      }

      this.setState({
        attachments: documents,
        files: [...this.state.files, ...e],
      });

      // let dataToPost = {
      //   transactionId: transId,
      //   location: "Transaction Docs",
      //   document: documents,
      // };

      // this.props.addDocAction(dataToPost).then((res) => {
      //   if (res.status === code.OK) {
      //     let fileUploadName = "";
      //     res.data.map((item) => {
      //       if (fileUploadName.length > 0) {
      //         fileUploadName +=
      //           "@@@" + item.document + "###" + item.uploadedFileName;
      //       } else {
      //         fileUploadName = item.document + "###" + item.uploadedFileName;
      //       }
      //     });

      //     this.props
      //       .uploadDocumentAction(formData, transId, undefined, fileUploadName)
      //       .then((res) => {
      //         //   console.log("VALID");
      //         this.props.logout();
      //       });
      //   } else {
      //     toastMessage(code.ERROR, res.data);
      //   }
      // });
    }
  }

  errorHandler(errors) {
    this.setState({
      errors: errors,
    });
  }

  render() {
    let attachments = this.state.attachments;
    // console.log("systemLoginValues-98", systemLoginValues);

    return (
      <div className="admin-steps admin-content-area">
        <StickyHeaderPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
        <div className="container-custom">
          <Form className="form-sm form-admin" id="formToExport">
            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-5 mb-3 pt-3">
                      Client Information
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group
                  controlId=""
                  className="dropzone-transaction-wrapper"
                >
                  <div className="mt-4">
                    <ImageUpload />
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    Client First Name<span className="text-danger"> *</span>:
                  </Form.Label>
                  <Form.Control
                    value={
                      this.state.clientFirstName
                        ? this.state.clientFirstName
                        : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientFirstName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientFirstName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientFirstName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Client Last Name:</Form.Label>
                  <Form.Control
                    value={
                      this.state.clientLastName ? this.state.clientLastName : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientLastName: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientLastName}
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientLastName}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Email:</Form.Label>
                  <Form.Control
                    value={this.state.clientEmail ? this.state.clientEmail : ""}
                    onChange={(e) =>
                      this.setState({ clientEmail: e.target.value })
                    }
                    isInvalid={!!this.state.errors.clientEmail}
                    type="email"
                    name="clientEmail"
                    id="clientEmail"
                  />
                  <Form.Control.Feedback type="invalid">
                    {this.state.errors.clientEmail}
                  </Form.Control.Feedback>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Mobile Number:</Form.Label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="clientPhone"
                    value={
                      this.state.clientPhone
                        ? formatPhoneNumber(this.state.clientPhone)
                        : ""
                    }
                    onChange={(e) =>
                      this.setState({ clientPhone: e.target.value })
                    }
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                  {this.state.errors.clientPhone && (
                    <div
                      className="invalid-feedback"
                      style={{ display: "block" }}
                    >
                      {this.state.errors.clientPhone}
                    </div>
                  )}
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Date of Birth:</Form.Label>
                  <InputMask
                    mask="99/99/9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="clientDob"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Address:</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>City:</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>State:</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Zip Code:</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
            </Row>
            {this.state.hasGuardian ? (
              <>
                <Row>
                  <Col xs={12} sm={7}>
                    <Row>
                      <Col xs={12}>
                        <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                          Guardian Information
                        </h4>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>
                        Name<span className="text-danger"> *</span>:
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="guardianName"
                        id="guardianName"
                        value={
                          this.state.guardianName ? this.state.guardianName : ""
                        }
                        onChange={(e) =>
                          this.setState({ guardianName: e.target.value })
                        }
                        isInvalid={!!this.state.errors.guardianName}
                      />
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.guardianName}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>Date of Birth:</Form.Label>
                      <InputMask
                        mask="99/99/9999"
                        maskChar=""
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="guardianDob"
                      >
                        {(inputProps) => <Form.Control {...inputProps} />}
                      </InputMask>
                    </Form.Group>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>Email:</Form.Label>
                      <Form.Control
                        value={
                          this.state.guardianEmail
                            ? this.state.guardianEmail
                            : ""
                        }
                        onChange={(e) =>
                          this.setState({ guardianEmail: e.target.value })
                        }
                        isInvalid={!!this.state.errors.guardianEmail}
                        type="email"
                        name="guardianEmail"
                        id="guardianEmail"
                      />
                      <Form.Control.Feedback type="invalid">
                        {this.state.errors.guardianEmail}
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col xs={12} sm={3}>
                    <Form.Group>
                      <Form.Label>Phone:</Form.Label>
                      <InputMask
                        mask="999-999-9999"
                        maskChar=""
                        formControlProps={{
                          fullWidth: true,
                        }}
                        name="guardianPhone"
                        value={
                          this.state.guardianPhone
                            ? formatPhoneNumber(this.state.guardianPhone)
                            : ""
                        }
                        onChange={(e) =>
                          this.setState({ guardianPhone: e.target.value })
                        }
                      >
                        {(inputProps) => <Form.Control {...inputProps} />}
                      </InputMask>
                      {this.state.errors.guardianPhone && (
                        <div
                          className="invalid-feedback"
                          style={{ display: "block" }}
                        >
                          {this.state.errors.guardianPhone}
                        </div>
                      )}
                    </Form.Group>
                  </Col>
                </Row>
              </>
            ) : (
              ""
            )}

            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Artwork Information
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Appointment Date:</Form.Label>
                  <Form.Control
                    value={
                      this.state.appointmentDate
                        ? this.state.appointmentDate
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artist Name:</Form.Label>
                  <Form.Control
                    value={this.state.artistName ? this.state.artistName : ""}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artwork Type:</Form.Label>
                  <Form.Control
                    value={this.state.artworkType ? this.state.artworkType : ""}
                  />
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Artwork Description:</Form.Label>
                  <Form.Control
                    value={
                      this.state.artworkDescription
                        ? this.state.artworkDescription
                        : ""
                    }
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Emergency Contact
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Name:</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Phone:</Form.Label>
                  <InputMask
                    mask="999-999-9999"
                    maskChar=""
                    formControlProps={{
                      fullWidth: true,
                    }}
                    name="emergencyPhone"
                  >
                    {(inputProps) => <Form.Control {...inputProps} />}
                  </InputMask>
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={7}>
                <Row>
                  <Col xs={12}>
                    <h4 className="title-medium font-600 mt-2 mb-3 pt-3">
                      Client Health Information
                    </h4>
                  </Col>
                </Row>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Label className="title-sm font-600">
                  Allergies:
                </Form.Label>
                <Form.Group>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Antibiotics
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Metals
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Soaps
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Latex
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Alcohol
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Cosmetics
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Adhesives
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Petroleum
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Lanolin Oil
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Lidocaine
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Shellfish
                    </label>
                  </div>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Label className="title-sm font-600">Diseases:</Form.Label>
                <Form.Group>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Hepatitis
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Tuberculosis
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Gonorrhea
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Syphilis
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      HIV/AIDS
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Herpes
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Staph
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Auto-Immunity
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Asthma
                    </label>
                  </div>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={3}>
                <Form.Label className="title-sm font-600">
                  Medical History:
                </Form.Label>
                <Form.Group>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Heart Disease
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      High Blood Pressure
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Diabetes
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Pregnant
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Prone to Fainting
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Skin Disease/Rash
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Epilepsy
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Hemophilia
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckDefault"
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                      Prone to Scarring/Keloiding
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Psoriasis
                    </label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value=""
                      id="flexCheckChecked"
                    />
                    <label class="form-check-label" for="flexCheckChecked">
                      Eczema
                    </label>
                  </div>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>How Long Since You Last Ate?</Form.Label>
                  <Form.Control />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>
                    {this.state.hasGuardian
                      ? "Guardian Signature"
                      : "Client Signature"}
                  </Form.Label>
                  <div
                    style={{
                      border: "solid 1px lightgray",
                      width: "400px",
                      height: "70px",
                    }}
                  >
                    <SignaturePad
                      canvasProps={{
                        width: 400,
                        height: 70,
                        className: "sigCanvas",
                      }}
                    />
                  </div>
                </Form.Group>
              </Col>
              <Col xs={12} sm={3}>
                <Form.Group>
                  <Form.Label>Date:</Form.Label>
                  <Form.Control value={moment().format("MM/DD/YYYY")} />
                </Form.Group>
              </Col>
            </Row>
          </Form>
        </div>
        <div style={{ marginBottom: "50px" }}>
          <Row>
            <Col xs={12} sm={3}>
              <div
                style={{
                  backgroundColor: "#f8f8f8",
                  padding: "20px",
                  margin: "25px",
                }}
              >
                <Dropzone
                  maxSize={100000000}
                  accept={[
                    "image/*",
                    "application/pdf",
                    "application/msword",
                    ".docx",
                    ".xml",
                    "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                  ]}
                  onDrop={(acceptedFiles) => {
                    this.uploadAttachments(
                      acceptedFiles,
                      this.state.transactionId
                    );
                  }}
                >
                  {({ getRootProps, getInputProps }) => (
                    <section>
                      <div
                        className="dropzone-transaction drop-task"
                        {...getRootProps()}
                      >
                        <input {...getInputProps()} />
                        <AttachFile />
                        <p>
                          <strong>
                            Click or drag and drop to add attachments
                          </strong>
                        </p>
                      </div>
                    </section>
                  )}
                </Dropzone>
              </div>
            </Col>
            <Col xs={12} sm={3}>
              <h4 className="user-name">Attachments</h4>
              <div className="comments-thread mt-0 ">
                {attachments
                  ? attachments.map((attachment, i) => {
                      return (
                        <Row className="user-list mx-0 align-items-center">
                          <Col className="pl-4">
                            <div className="comments-text">
                              <a>
                                <h4 className="user-name">
                                  {attachment.fileName}
                                </h4>
                              </a>
                            </div>
                          </Col>
                          <Col>
                            <Button
                              variant="transparent"
                              onClick={() => {
                                this.deleteImage(i);
                              }}
                            >
                              <DeleteOutline />
                            </Button>
                          </Col>
                        </Row>
                      );
                    })
                  : ""}
              </div>
            </Col>
          </Row>
        </div>
        <FooterPublic
          form={this.props.formData && this.props.formData.form}
          exportFormToPDF={this.exportFormToPDF.bind(this)}
          errorHandler={this.errorHandler.bind(this)}
          transaction={this.state}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    transactionData: state.reducer.transactionData,
  };
};

export default connect(mapStateToProps, {
  publicUploadDocumentAction,
  publicAddDocAction,
  logout,
  loginUserAction,
  getPublicFormTransactionDataAction,
  loginUserPublicFormsAction,
  addContactByPublicFormAction
})(IntakePublic);
